// PublicPaths.js

export function normalizePublicPath(value) {
    return String(value || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}

export function getWorkspacePathValue(workspace) {
    return normalizePublicPath(workspace?.path || workspace?.slug || '');
}

export function getPagePathValue(page) {
    return normalizePublicPath(page?.path || page?.slug || '');
}

export function getNodePathValue(node) {
    const publicPath = typeof node?.publicPath === 'string' ? node.publicPath : '';
    return normalizePublicPath(publicPath);
}

export function getPortalPathValue(portal) {
    return normalizePublicPath(portal?.path || portal?.slug || '');
}

export function buildPublicPageRoute({
    workspacePath,
    pagePath,
    fallbackWorkspacePath = 'your-workspace',
    fallbackPagePath = 'your-page',
} = {}) {
    const resolvedWorkspacePath = normalizePublicPath(workspacePath) || fallbackWorkspacePath;
    const resolvedPagePath = normalizePublicPath(pagePath) || fallbackPagePath;

    return `/p/${resolvedWorkspacePath}/${resolvedPagePath}`;
}

export function buildPublicPortalRoute({
    workspacePath,
    nodePath,
    portalPath,
    fallbackWorkspacePath = 'your-workspace',
    fallbackNodePath = 'your-node',
    fallbackPortalPath = 'your-portal',
} = {}) {
    const resolvedWorkspacePath = normalizePublicPath(workspacePath) || fallbackWorkspacePath;
    const resolvedNodePath = normalizePublicPath(nodePath) || fallbackNodePath;
    const resolvedPortalPath = normalizePublicPath(portalPath) || fallbackPortalPath;

    return `/p/${resolvedWorkspacePath}/${resolvedNodePath}/${resolvedPortalPath}`;
}